import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  TextField,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio, FormControl, Select,
  MenuItem, InputLabel, ListItemText, Checkbox, Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  Tab,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Chip,
  useTheme,
  Divider,
} from "@mui/material";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import MobileSpecialPrayerModal from "../components/MobileSpecialPrayerModal";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Helmet } from "react-helmet";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useParams, useNavigate } from 'react-router-dom';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles
import { useUser } from "../context/UserContext";
import Toast from "../components/Toast";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import HelpTooltip from "../components/HelpTooltip";
import DateTimeRangePicker from "../components/DateTimeRangePicker";
import PrayerVideoManager from "../components/PrayerVideoManager";
import UploadFileIcon from "@mui/icons-material/UploadFile";



const DEFAULT_FALLBACK_TEMPLATES = Array.from({ length: 23 }, (_, idx) => {
  const num = idx + 1;
  return {
    id: num,
    title: `Template ${num}`,
    url: `/prayforthenation/template${num}.jpg`,
  };
});

const getTemplateImageUrl = (url, baseUrl) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const cleanUrl = url.startsWith('/') ? url : `/${url}`;
  if (baseUrl) {
    const cleanBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return `${cleanBase}${cleanUrl}`;
  }
  return cleanUrl;
};

export default function EditSpecialPrayer() {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const [prayerStatus, setPrayerStatus] = useState('inactive');
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [prayerPlan, setPrayerPlan] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setTodate] = useState("");
  const [fromTime, setfromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [numberOfDays, setNumberOfDays] = useState("");
  const [slotDuration, setSlotDuration] = useState("");
  const [prayerType, setPrayerType] = useState("Group");
  const [talkItOver, setTalkItOver] = useState(true);
  const [prayerFrequency, setPrayerFrequency] = useState("Daily");

  const [daysOfWeek, setDaysOfWeek] = useState([]);
  const [scriptures, setScriptures] = useState([{ id: '', scripture: '' }]);

  const [templatesList, setTemplatesList] = useState(DEFAULT_FALLBACK_TEMPLATES);

  const [prayerPoints, setPrayerPoints] = useState([
    { title: '', telugu: '', english: '' }
  ]);

  const [selectedTemplateId, setSelectedTemplateId] = useState(24);
  const [showAllTemplates, setShowAllTemplates] = useState(false);
  const [templateModalOpen, setTemplateModalOpen] = useState(false);

  const currentActiveTemplate = React.useMemo(() => {
    if (!Array.isArray(templatesList) || templatesList.length === 0) return null;
    return templatesList.find(t => String(t.id) === String(selectedTemplateId)) || null;
  }, [templatesList, selectedTemplateId]);
  const [categories, setCategories] = useState([]);

  const [loading, setLoading] = useState(false);
  const [generatedPoints, setGeneratedPoints] = useState([]); // API response
  const [pointCount, setPointCount] = useState(0);
  const [customTemplateTitle, setCustomTemplateTitle] = useState("");
  const [customTemplateFile, setCustomTemplateFile] = useState(null);
  const [customTemplatePreview, setCustomTemplatePreview] = useState("");
  const [basicInfoModal, setBasicInfoModal] = useState({ open: false, mode: 'example' });
  const [numDays, setNumDays] = useState(0);
  const [dayWiseData, setDayWiseData] = useState({});
  const [sameContentForAllDays, setSameContentForAllDays] = useState(false);
  const [currentDay, setCurrentDay] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;
  const Image_URL = process.env.REACT_APP_Image_URL;

  const [orgId, setOrgId] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [existingImage, setExistingImage] = useState("");

  const navigate = useNavigate();
  const { user, isSwitched, effectiveOrgId } = useUser();
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  // Delete confirmation dialog states
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState(null);

  const { id } = useParams();

  // Auto calculate days
  useEffect(() => {
    let totalDays = 0;
    if (prayerPlan === "fixed" || prayerPlan === "open") {
      if (fromDate && toDate) {
        const from = new Date(fromDate);
        const to = new Date(toDate);
        if (to >= from) {
          totalDays = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
        }
      }
    } else if (prayerPlan === "floating") {
      totalDays = numberOfDays && Number(numberOfDays) > 0 ? Number(numberOfDays) : 0;
    } else if (prayerPlan === "chain") {
      if (fromDate && toDate) {
        const from = new Date(fromDate);
        const to = new Date(toDate);
        if (to >= from) {
          totalDays = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
        } else {
          totalDays = 1;
        }
      } else if (numberOfDays && Number(numberOfDays) > 0) {
        totalDays = Number(numberOfDays);
      } else {
        totalDays = 1;
      }
    }

    if (totalDays > 0) {
      setNumDays(totalDays);
      setDayWiseData((prev) => {
        const newData = {};
        const baseDay1 = prev[1] || {
          title: "", description: "",
          te_title: "", te_description: "",
          ta_title: "", ta_description: "",
          ml_title: "", ml_description: "",
          hi_title: "", hi_description: "",
          currentLang: "en",
          prayerPoints: []
        };
        for (let i = 1; i <= totalDays; i++) {
          if (sameContentForAllDays && i > 1) {
            newData[i] = {
              ...JSON.parse(JSON.stringify(baseDay1)),
              id: prev[i]?.id || null,
            };
            if (baseDay1.image) newData[i].image = baseDay1.image;
          } else {
            newData[i] = prev[i] || {
              title: "", description: "",
              te_title: "", te_description: "",
              ta_title: "", ta_description: "",
              ml_title: "", ml_description: "",
              hi_title: "", hi_description: "",
              currentLang: "en",
              prayerPoints: []
            };
          }
        }
        return newData;
      });

      setCurrentDay((prev) => {
        if (!prev || prev < 1 || prev > totalDays) {
          return 1;
        }
        return prev;
      });
    }
  }, [fromDate, toDate, numberOfDays, prayerPlan, sameContentForAllDays]);

  useEffect(() => {
    fetchCategories();
    fetchTemplates();
  }, []);

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}roles-organizations`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (data.organizations) {
          setOrganizations(data.organizations);
        }
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };
    if (user?.role === 1 && !isSwitched) {
      fetchOrganizations();
    }
  }, [user, isSwitched, API_URL]);


  const handleCustomTemplateUpload = async (e) => {
    const file = e.target.files[0];
    console.log('Selected custom template file:', file);

    // setCustomTemplateTitle("");
    // setCustomTemplateFile(null);
    // setCustomTemplatePreview("");

    if (!file) return;

    // 1️⃣ File size check
    if (file.size > 200 * 1024) {
      alert("Please upload an image smaller than 200KB.");

      setCustomTemplateFile(null);
      setCustomTemplatePreview("");
      return;
    }

    // 2️⃣ Banner dimension check (wide, not tall)
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const aspect = img.width / img.height;

      // Accept if width is at least 1.5 times height (banner layout)
      if (aspect < 1.5) {
        alert("Please upload a wide banner-style image (example: 1200×600).");
        setCustomTemplateFile(null);
        setCustomTemplatePreview("");
        return;
      }

      // Valid
      setCustomTemplateFile(file);
      setCustomTemplatePreview(img.src);
    };
  };
  const fetchTemplates = async () => {
    // Replace this with your actual API call
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}template-list`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
      })
    });
    const data = await response.json();

    if (!response.ok || data.success === false) {
      // 🔑 Handle invalid token
      if (data.message === 'Invalid token') {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
    }
    const list = Array.isArray(data?.data) && data.data.length > 0 ? data.data : DEFAULT_FALLBACK_TEMPLATES;
    setTemplatesList(list);
    if (list.length > 0) {
      setSelectedTemplateId((prev) => prev || list[0]?.id || 1);
    }
  }
  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}special-prayer-categories`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
      });
      const data = await response.json();

    if (!response.ok || data.success === false) {
      if (data.message === 'Invalid token') {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
    }

    if (data?.data?.categories) {
      setCategories(data.data.categories);
    }
  } catch (err) {
    console.error("Error fetching special prayer categories:", err);
  }
};

  // Handle template delete button click
  const handleDeleteClick = (template) => {
    setTemplateToDelete(template);
    setDeleteDialogOpen(true);
  };

  // Handle template deletion confirmation
  const handleDeleteConfirm = async () => {
    if (!templateToDelete) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}delete-template`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          template_id: templateToDelete.id
        })
      });

      const data = await response.json();

      if (!response.ok || data.success === false) {
        if (data.message === 'Invalid token') {
          localStorage.removeItem('token');
          window.location.href = '/login';
          return;
        }

        setToast({
          open: true,
          message: data.message || 'Failed to delete template',
          severity: 'error'
        });
        setDeleteDialogOpen(false);
        setTemplateToDelete(null);
        return;
      }

      // Success
      setToast({
        open: true,
        message: data.message || 'Template deleted successfully',
        severity: 'success'
      });

      // Refresh templates list
      await fetchTemplates();

      // If deleted template was selected, select first template
      if (selectedTemplateId === templateToDelete.id && (templatesList || []).length > 1) {
        setSelectedTemplateId((templatesList || []).find(t => t.id !== templateToDelete.id)?.id);
      }

      setDeleteDialogOpen(false);
      setTemplateToDelete(null);

    } catch (error) {
      console.error('Error deleting template:', error);
      setToast({
        open: true,
        message: 'Network error occurred',
        severity: 'error'
      });
      setDeleteDialogOpen(false);
      setTemplateToDelete(null);
    }
  };

  // Check if user can delete a template
  const canDeleteTemplate = (template) => {
    if (!user) return false;

    // Super admin (role 1) can only delete templates with org_id null
    if (user.role === 1) {
      return template.org_id === null || template.org_id === undefined;
    }

    // Other roles can only delete their own organization's templates
    return template.org_id === user.org_id;
  };


  useEffect(() => {
    fetchSpecialPrayer();
  }, []);

  const fetchSpecialPrayer = async () => {
    // Replace this with your actual API call
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}special-prayer-details`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id
      })
    });
    const data = await response.json();

    if (!response.ok || data.success === false) {
      // 🔑 Handle invalid token
      if (data.message === 'Invalid token') {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
    }

    setTitle(data.data.title);
    setCategory(data.data.category);
    setSlotDuration(data.data.slots);
    setDescription(data.data.description);
    setPrayerPlan(data.data.flow_type);
    setFromDate(data.data.from_date);
    setTodate(data.data.to_date);
    setfromTime(data.data.from_time);
    setToTime(data.data.to_time);
    setNumberOfDays(data.data.number_of_days);

    setPrayerType(data.data.prayer_type);
    setPrayerFrequency(data.data.pray_for);
    if (data.data.talk_it_over !== undefined) {
      setTalkItOver(data.data.talk_it_over !== 'no' && data.data.talk_it_over !== false && data.data.talk_it_over !== 'false');
    }
    if (data.data.day_of_week) {
      setDaysOfWeek(
        typeof data.data.day_of_week === 'string'
          ? data.data.day_of_week.split(',').map(s => s.trim()).filter(Boolean)
          : []
      );
    } else {
      setDaysOfWeek([]);
    }
    setSelectedTemplateId(data.data.tempId);
    setExistingImage(data.data.image || "");
    setOrgId(data.data.org_id);
    setPrayerStatus(data.data.status || 'inactive');

    if (data.data?.session_prayer_points?.length) {

      transformDayWiseData(data.data.session_prayer_points);

    }



  };



  // Assuming `session_prayer_points` comes from backend
  const transformDayWiseData = (sessionPrayerPoints) => {
    const dayWiseData = {};

    sessionPrayerPoints.forEach((point) => {
      const day = point.day;

      if (!dayWiseData[day]) {
        let parsedImage = point.day_img;
        let parsedVideos = [];
        let parsedVideoUrl = '';
        let parsedVideoTitle = '';
        let parsedVideoThumbnail = '';

        if (point.day_img) {
          try {
            if (typeof point.day_img === 'string' && (point.day_img.trim().startsWith('{') || point.day_img.trim().startsWith('['))) {
              const parsed = JSON.parse(point.day_img);
              if (parsed && typeof parsed === 'object') {
                parsedImage = parsed.image || '';
                parsedVideos = Array.isArray(parsed.videos) ? parsed.videos : [];
                parsedVideoUrl = parsed.video_url || (parsedVideos[0]?.url || '');
                parsedVideoTitle = parsed.video_title || (parsedVideos[0]?.title || '');
                parsedVideoThumbnail = parsed.video_thumbnail || (parsedVideos[0]?.thumbnail || '');
                if (parsedVideos.length === 0 && parsedVideoUrl) {
                  parsedVideos = [{
                    id: 'vid-1',
                    url: parsedVideoUrl,
                    title: parsedVideoTitle || 'Prayer Video',
                    thumbnail: parsedVideoThumbnail,
                    is_published: true,
                    order: 1
                  }];
                }
              }
            }
          } catch (e) {
            parsedImage = point.day_img;
          }
        }

        dayWiseData[day] = {
          title: point.category,
          id: point.id,
          description: point.prayer_point,
          image: parsedImage, // Map existing image
          videos: parsedVideos,
          video_url: parsedVideoUrl,
          video_title: parsedVideoTitle,
          video_thumbnail: parsedVideoThumbnail,
          te_title: point.te_category || "",
          te_description: point.te_prayer_point || "",
          ta_title: point.ta_category || "",
          ta_description: point.ta_prayer_point || "",
          ml_title: point.ml_category || "",
          ml_description: point.ml_prayer_point || "",
          hi_title: point.hi_category || "",
          hi_description: point.hi_prayer_point || "",
          currentLang: "en",
          prayerPoints: [],
        };
      } else {
        // Next entries → push into prayerPoints
        dayWiseData[day].prayerPoints.push({
          title: point.category,
          description: point.prayer_point,
          id: point.id,
          te_title: point.te_category || "",
          te_description: point.te_prayer_point || "",
          ta_title: point.ta_category || "",
          ta_description: point.ta_prayer_point || "",
          ml_title: point.ml_category || "",
          ml_description: point.ml_prayer_point || "",
          hi_title: point.hi_category || "",
          hi_description: point.hi_prayer_point || "",
          currentLang: "en",
        });
      }
    });

    setDayWiseData(dayWiseData);
    // console.log("Transformed Day Wise Data:", dayWiseData);
  };




  const handleAddPrayerPoint = () => {
    setPrayerPoints([...prayerPoints, { title: '', telugu: '', english: '' }]);
  };

  const handlePrayerPointChange = (index, field, value) => {
    const updated = [...prayerPoints];
    updated[index][field] = value;
    setPrayerPoints(updated);
  };


  const handleAddDevotion = async (publishToLive = true) => {
    const token = localStorage.getItem('token');

    if (publishToLive) {
      const cleanTitle = title ? String(title).trim() : '';
      const cleanDesc = description ? description.replace(/<[^>]+>/g, '').trim() : '';
      if (!cleanTitle || !category || !cleanDesc || !fromTime || !toTime || !slotDuration) {
        setToast({ open: true, message: "To publish live, Category, Title, Description, From Time, To Time and Slot duration are required.", severity: "error" });
        return false;
      }

      if (prayerPlan == 'fixed' || prayerPlan == 'open') {
        if (fromDate == '' || toDate == '') {
          setToast({ open: true, message: "From Date and To Date are required.", severity: "error" });
          return false;
        } else if (new Date(toDate) <= new Date(fromDate)) {
          setToast({ open: true, message: "To Date must be later than From Date", severity: "error" });
          return false;
        }
      }

      if (fromTime && toTime && toTime <= fromTime) {
        setToast({ open: true, message: "To Time must be later than From Time", severity: "error" });
        return false;
      }

      if (prayerPlan == 'floating') {
        if (numberOfDays == '') {
          setToast({ open: true, message: "Number of days is required", severity: "error" });
          return false;
        }
      }

      if (prayerFrequency == 'Weekly') {
        if (daysOfWeek.length < 1) {
          setToast({ open: true, message: "Day of week is required", severity: "error" });
          return false;
        }
      }

      if (dayWiseData && Object.keys(dayWiseData).length > 0) {
        for (var day in dayWiseData) {
          var dayData = dayWiseData[day];
          if (dayData.prayerPoints && dayData.prayerPoints.length > 0) {
            for (var i = 0; i < dayData.prayerPoints.length; i++) {
              const pt = dayData.prayerPoints[i];
              const titleVal = pt.title ? String(pt.title).trim() : '';
              const descVal = (pt.description || pt.english || pt.prayer_point) ? String(pt.description || pt.english || pt.prayer_point).trim() : '';
              if (titleVal === '' || descVal === '') {
                setToast({ open: true, message: 'Day ' + day + ' Prayer Point ' + (i + 1) + ' Title and Description are required', severity: "error" });
                return false;
              }
            }
          }
        }
      } else {
        setToast({ open: true, message: "Please add prayer content for at least one day.", severity: "error" });
        return false;
      }
    } else {
      // Soft validation for draft/pending save
      if (!title || String(title).trim() === '') {
        setToast({ open: true, message: "Please enter at least a title to save your draft.", severity: "warning" });
        return false;
      }
    }

    const formData = new FormData();
    formData.append('customTemplateTitle', customTemplateTitle);
    formData.append('customTemplateFile', customTemplateFile);

    formData.append('title', title);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('prayerPlan', prayerPlan);
    formData.append('fromDate', prayerPlan === 'floating' ? '' : fromDate);
    formData.append('toDate', prayerPlan === 'floating' ? '' : toDate);

    formData.append('fromTime', fromTime);
    formData.append('toTime', toTime);
    formData.append('numberOfDays', prayerPlan === 'floating' ? numberOfDays : (numDays || ''));
    formData.append('slotDuration', slotDuration);
    formData.append('prayerType', prayerType);
    formData.append('talk_it_over', talkItOver ? 'yes' : 'no');
    formData.append('prayerFrequency', prayerFrequency);
    formData.append('daysOfWeek', JSON.stringify(daysOfWeek));
    formData.append('status', publishToLive ? 'active' : 'inactive');

    const matchedTemplate = (templatesList || []).find(t => t.id === selectedTemplateId);
    if (matchedTemplate?.url) {
      formData.append('selectedTemplateId', matchedTemplate.url);
    }
    if (selectedTemplateId) {
      formData.append('tempId', selectedTemplateId);
    }

    let finalDayWiseData = { ...dayWiseData };
    if (sameContentForAllDays && numDays > 1 && finalDayWiseData[1]) {
      for (let d = 2; d <= numDays; d++) {
        finalDayWiseData[d] = {
          ...JSON.parse(JSON.stringify(finalDayWiseData[1])),
          id: finalDayWiseData[d]?.id || null,
        };
        if (finalDayWiseData[1].image) {
          finalDayWiseData[d].image = finalDayWiseData[1].image;
        }
      }
    }

    // Append images from dayWiseData
    if (finalDayWiseData && Object.keys(finalDayWiseData).length > 0) {
      for (const day in finalDayWiseData) {
        const dayData = finalDayWiseData[day];
        if (dayData.image instanceof File) {
          formData.append(`day_${day}_image`, dayData.image);
        }

      }
    }

    formData.append('dayWiseData', JSON.stringify(finalDayWiseData));
    formData.append('id', id);
    const targetOrg = isSwitched
      ? (effectiveOrgId || user?.org_id)
      : (user?.role === 1 ? (orgId || 'global') : user?.org_id);

    if (targetOrg && targetOrg !== 'global') {
      formData.append('organization', targetOrg);
      formData.append('organization_id', targetOrg);
    } else if (user?.role === 1 && !isSwitched) {
      formData.append('organization', orgId || 'global');
    }

    const response = await fetch(`${API_URL}update-special-prayer`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        ...(targetOrg && targetOrg !== 'global' ? { 'x-org-id': String(targetOrg) } : {})
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok || data.success === false) {
      // 🔑 Handle invalid token
      if (data.message === 'Invalid token') {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
      setToast({ open: true, message: "Update failed: " + (data?.message || data?.error || 'Unknown error'), severity: "error" });
      return;
    }

    setToast({
      open: true,
      message: publishToLive
        ? "Special prayer updated and published live to mobile app! 🎉"
        : "Special prayer changes saved to Pending Reviews successfully!",
      severity: "success"
    });
    setPrayerStatus(publishToLive ? 'active' : 'inactive');
    setTimeout(() => {
      navigate(publishToLive ? '/admin/special-prayers?tab=active' : '/admin/special-prayers?tab=pending');
    }, 1200);
  };


  const handleGenerateDays = () => {
    let totalDays = 0;

    if (prayerPlan === "fixed") {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      if (!fromDate || !toDate || to < from)
        return setToast({ open: true, message: "Please select valid dates.", severity: "error" });
      totalDays = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
    } else if (prayerPlan === "floating") {
      if (!numberOfDays || numberOfDays < 1)
        return setToast({ open: true, message: "Please enter number of days.", severity: "error" });
      totalDays = numberOfDays;
    }

    setNumDays(totalDays);
    setCurrentDay(1); // Open day 1 by default
  };

  const generatePrayerPoints = async () => {
    setLoading(true);
    setGeneratedPoints([]);
    try {
      const country_code = "in";
      const no_of_prayers = 20;

      const res = await fetch(
        `http://64.227.157.61:8004/generate-prayers?country=in&count=5`
      );
      const data = await res.json();

      let formatted = data.formatted_output
        .replace(/<think>[\s\S]*?<\/think>/gi, "")
        .replace(/```json|```/gi, "")
        .trim();

      const correctData = JSON.parse(formatted);

      if (correctData && Array.isArray(correctData)) {
        // Flatten points with category
        const parsedPoints = [];
        correctData.forEach((section) => {
          section.prayer_points.forEach((point) => {
            parsedPoints.push({
              id: ++pointCount,
              title: section.category.replace(/\s*\d+\.\s*/, " "),
              english: point.en,
              telugu: point.te,
            });
          });
        });
        setGeneratedPoints(parsedPoints);
        setPointCount(pointCount);
      }
    } catch (err) {
      console.error("Error:", err);
    }
    setLoading(false);
  };
  const approvePrayerPoint = (index) => {
    const point = generatedPoints[index];

    const newApproved = {
      id: Date.now(), // new unique id
      title: point.title,
      english: point.english,
      telugu: point.telugu,
    };

    setPrayerPoints((prev) => [...prev, newApproved]);
  };



  const handleOpenDay = (day) => {
    saveCurrentDay(); // save the previous day's data
    setCurrentDay(day);
    // console.log('dayWiseData:', dayWiseData);
    //     console.log('Opened Day:', day, 'with data:', dayWiseData[day]);
  };

  const handleToggleSameContent = (checked) => {
    setSameContentForAllDays(checked);
    if (checked && numDays > 1) {
      const day1 = dayWiseData[1];
      if (day1) {
        setDayWiseData((prev) => {
          const updated = { ...prev };
          for (let d = 2; d <= numDays; d++) {
            updated[d] = {
              ...JSON.parse(JSON.stringify(day1)),
              id: prev[d]?.id || null,
            };
            if (day1.image) updated[d].image = day1.image;
          }
          return updated;
        });
        setToast({ open: true, message: `Day 1 content synced across all ${numDays} days!`, severity: "info" });
      }
    }
  };

  const handleApplyDay1ToAll = () => {
    const day1 = dayWiseData[1];
    if (!day1) {
      setToast({ open: true, message: "Please configure Day 1 first.", severity: "warning" });
      return;
    }
    const updated = { ...dayWiseData };
    for (let d = 2; d <= numDays; d++) {
      updated[d] = {
        ...JSON.parse(JSON.stringify(day1)),
        id: dayWiseData[d]?.id || null,
      };
      if (day1.image) updated[d].image = day1.image;
    }
    setDayWiseData(updated);
    setToast({ open: true, message: `Day 1 content successfully applied to all ${numDays} days!`, severity: "success" });
  };

  const saveCurrentDay = () => {
    if (currentDay !== null) {
      setDayWiseData((prev) => {
        if (sameContentForAllDays) {
          const base = prev[currentDay] || {};
          const updated = { ...prev };
          for (let d = 1; d <= numDays; d++) {
            updated[d] = {
              ...updated[d],
              title: base.title || '',
              description: base.description || '',
              prayerPoints: base.prayerPoints || [],
            };
          }
          return updated;
        }
        return {
          ...prev,
          [currentDay]: {
            ...prev[currentDay],
            title: prev[currentDay]?.title || '',
            description: prev[currentDay]?.description || '',
            prayerPoints: prev[currentDay]?.prayerPoints || [],
          },
        };
      });
    }
  };

  const handleInputChange = (field, value) => {
    setDayWiseData(prev => {
      if (sameContentForAllDays) {
        const updated = { ...prev };
        for (let d = 1; d <= numDays; d++) {
          updated[d] = {
            ...(prev[d] || {}),
            [field]: value
          };
        }
        return updated;
      }
      return {
        ...prev,
        [currentDay]: {
          ...prev[currentDay],
          [field]: value
        }
      };
    });
  };

  const handleDailyPrayerPointChange = (index, field, value) => {
    setDayWiseData(prev => {
      if (sameContentForAllDays) {
        const updated = { ...prev };
        for (let d = 1; d <= numDays; d++) {
          const existingDay = prev[d] || { id: null, title: '', description: '', prayerPoints: [] };
          const updatedPoints = [...(existingDay.prayerPoints || [])];
          if (updatedPoints[index]) {
            updatedPoints[index] = {
              ...updatedPoints[index],
              [field]: value
            };
            updated[d] = {
              ...existingDay,
              prayerPoints: updatedPoints
            };
          }
        }
        return updated;
      }
      const existingDay = prev[currentDay] || { id: null, title: '', description: '', prayerPoints: [] };
      const updatedPoints = [...existingDay.prayerPoints];
      if (updatedPoints[index]) {
        updatedPoints[index] = {
          ...updatedPoints[index],
          [field]: value
        };
      }
      return {
        ...prev,
        [currentDay]: {
          ...existingDay,
          prayerPoints: updatedPoints
        }
      };
    });
  };

  const addPrayerPoint = () => {
    const newPoint = {
      title: "", description: "",
      te_title: "", te_description: "",
      ta_title: "", ta_description: "",
      ml_title: "", ml_description: "",
      hi_title: "", hi_description: "",
      currentLang: "en"
    };
    setDayWiseData(prev => {
      if (sameContentForAllDays) {
        const updated = { ...prev };
        for (let d = 1; d <= numDays; d++) {
          const existingDay = prev[d] || {};
          const safePrayerPoints = Array.isArray(existingDay.prayerPoints) ? existingDay.prayerPoints : [];
          updated[d] = {
            ...existingDay,
            prayerPoints: [...safePrayerPoints, JSON.parse(JSON.stringify(newPoint))]
          };
        }
        return updated;
      }
      const existingDay = prev[currentDay] || {};
      const safePrayerPoints = Array.isArray(existingDay.prayerPoints) ? existingDay.prayerPoints : [];
      return {
        ...prev,
        [currentDay]: {
          ...existingDay,
          prayerPoints: [...safePrayerPoints, newPoint]
        }
      };
    });
  };

  const removePrayerPoint = (index) => {
    setDayWiseData((prev) => {
      if (sameContentForAllDays) {
        const updated = { ...prev };
        for (let d = 1; d <= numDays; d++) {
          const updatedPoints = [...(prev[d]?.prayerPoints || [])];
          updatedPoints.splice(index, 1);
          updated[d] = {
            ...prev[d],
            prayerPoints: updatedPoints,
          };
        }
        return updated;
      }
      const updatedPoints = [...(prev[currentDay]?.prayerPoints || [])];
      updatedPoints.splice(index, 1);
      return {
        ...prev,
        [currentDay]: {
          ...prev[currentDay],
          prayerPoints: updatedPoints,
        },
      };
    });
  };

  const translateText = async (text, targetLang) => {
    if (!text) return "";
    try {
      const response = await fetch(`https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`);
      const data = await response.json();
      return data[0].map(x => x[0]).join('');
    } catch (error) {
      console.error("Translation failed", error);
      return text; // Fallback
    }
  };

  const handleTranslatePrayerPoint = async (index, targetLang) => {
    const item = dayWiseData[currentDay]?.prayerPoints[index];
    if (!item) return;

    const title = item.title;
    const desc = item.description;

    if (!title && !desc) {
      setToast({ open: true, message: "Please enter English content first", severity: "warning" });
      return;
    }

    const translatedTitle = await translateText(title, targetLang);
    const translatedDesc = await translateText(desc, targetLang);

    setDayWiseData((prev) => {
      const updatedPoints = [...(prev[currentDay]?.prayerPoints || [])];
      if (updatedPoints[index]) {
        updatedPoints[index][`${targetLang}_title`] = translatedTitle;
        updatedPoints[index][`${targetLang}_description`] = translatedDesc;
        updatedPoints[index].currentLang = targetLang;
      }
      return {
        ...prev,
        [currentDay]: { ...prev[currentDay], prayerPoints: updatedPoints }
      };
    });
  };

  const handleTranslateDayContent = async (targetLang) => {
    const title = dayWiseData[currentDay]?.title;
    const desc = dayWiseData[currentDay]?.description;

    if (!title && !desc) {
      setToast({ open: true, message: "Please enter English content first", severity: "warning" });
      return;
    }

    const translatedTitle = await translateText(title, targetLang);
    const translatedDesc = await translateText(desc, targetLang);

    setDayWiseData((prev) => ({
      ...prev,
      [currentDay]: {
        ...prev[currentDay],
        [`${targetLang}_title`]: translatedTitle,
        [`${targetLang}_description`]: translatedDesc,
        currentLang: targetLang
      }
    }));
  };


  // console.log(dayWiseData)
  return (
    <>
      <Helmet>
        <title>Edit Special Prayer - GPN</title>
      </Helmet>
      <Box display="flex" justifyContent="center" sx={{ minHeight: '100vh', py: 4, px: 2 }}>
        <Paper elevation={0} sx={{ width: "100%", maxWidth: "1000px", borderRadius: 3, overflow: 'hidden', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column' }}>

          {/* Header */}
          <Box sx={{ background: 'linear-gradient(135deg, #0F2027 0%, #203A43 50%, #2C5364 100%)', p: { xs: 2.5, sm: 3.5 }, color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
            <Box>
              <Typography variant="h5" fontWeight={700} letterSpacing={1}>
                Edit Special Prayer
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.5, maxWidth: '600px' }}>
                Modify the schedule, content, and settings for this prayer session.
              </Typography>
            </Box>
            <Tooltip title="Close and return to Prayer Closet">
              <IconButton
                onClick={() => navigate('/admin/prayer-closet?tab=prayers')}
                aria-label="Close"
                sx={{
                  color: 'rgba(255, 255, 255, 0.85)',
                  bgcolor: 'rgba(255, 255, 255, 0.08)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '8px',
                  p: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    bgcolor: 'rgba(239, 68, 68, 0.25)',
                    borderColor: 'rgba(239, 68, 68, 0.5)',
                    color: '#EF4444',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <Box sx={{ p: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column', gap: 2 }}>

            {/* Basic Info Section */}
            <Accordion defaultExpanded sx={{ border: '1px solid #256974ff', borderRadius: '12px !important', boxShadow: 'none', '&:before': { display: 'none' } }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} sx={{ background: '#256974ff', borderBottom: '1px solid #e2e8f0' }}>
                <Typography fontWeight={600} color="#fff">Basic Information</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 3 }}>
                {/* TOP: User Example & Talk It Over Option in One Line */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  gap={2}
                  mb={2.5}
                  p={1.5}
                  borderRadius={2}
                  border="1px solid"
                  borderColor={isLight ? 'rgba(13, 148, 136, 0.25)' : 'rgba(56, 189, 248, 0.25)'}
                  bgcolor={isLight ? 'rgba(13, 148, 136, 0.04)' : 'rgba(56, 189, 248, 0.05)'}
                >
                  {/* Left: User Example Button */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <Button
                      size="small"
                      variant="contained"
                      startIcon={<PhoneIphoneIcon sx={{ fontSize: 18, color: '#FFFFFF' }} />}
                      onClick={() => setBasicInfoModal({ open: true, mode: 'example' })}
                      sx={{
                        borderRadius: '8px',
                        textTransform: 'none',
                        background: 'linear-gradient(135deg, #0F766E 0%, #14B8A6 100%)',
                        color: '#FFFFFF',
                        fontWeight: 700,
                        px: 1.8,
                        height: 36,
                        boxShadow: '0 2px 8px rgba(15, 118, 110, 0.35)',
                        '&:hover': { background: 'linear-gradient(135deg, #115E59 0%, #0F766E 100%)' }
                      }}
                    >
                      User Example
                    </Button>
                    <HelpTooltip
                      title="User Example"
                      purpose="Interactive mobile app simulator showing how this prayer appears to users."
                      howItWorks="Renders a smartphone mockup matching the mobile app prayer screen."
                      mobileEffect="Provides a design reference for title, banner image, and description."
                    />
                  </Box>

                  {/* Right: Talk It Over Option */}
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Box display="flex" alignItems="center" gap={0.8}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: isLight ? '#0F766E' : '#38BDF8' }}>
                        Talk It Over Option
                      </Typography>
                      <HelpTooltip
                        title="Talk It Over"
                        purpose="Enables intercessors to connect with a prayer partner to discuss insights and reflections during this prayer."
                        howItWorks="When selected, users see the Talk It Over card and can participate in partner reflection. Uncheck if you want to hide this option."
                        mobileEffect="Controls visibility of the Talk It Over feature in the mobile app for this prayer."
                      />
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={talkItOver}
                          onChange={(e) => setTalkItOver(e.target.checked)}
                          sx={{ color: isLight ? '#0D9488' : '#38BDF8', '&.Mui-checked': { color: isLight ? '#0D9488' : '#38BDF8' } }}
                        />
                      }
                      label={
                        <Typography variant="body2" sx={{ fontWeight: 600, color: talkItOver ? (isLight ? '#0F766E' : '#38BDF8') : '#94A3B8' }}>
                          {talkItOver ? "Enabled (Default)" : "Disabled"}
                        </Typography>
                      }
                      sx={{ m: 0 }}
                    />
                  </Box>
                </Box>

                <Box display="flex" flexWrap="wrap" gap={2} justifyContent="space-between">
                  {user?.role === 1 && !isSwitched && (
                    <Box flex="1 1 100%" mb={1}>
                      <FormControl fullWidth>
                        <InputLabel>Select Organization</InputLabel>
                        <Select
                          label="Select Organization"
                          value={orgId ? orgId : "global"}
                          onChange={(e) => setOrgId(e.target.value === "global" ? null : e.target.value)}
                        >
                          <MenuItem value="global">
                            <em>Glocal Prayer Network (Global)</em>
                          </MenuItem>
                          {organizations.map((org) => (
                            <MenuItem key={org.id} value={org.id}>
                              {org.org_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                  {/* Title */}
                  <Box flex="1 1 48%">
                    <TextField label="Title" value={title} required fullWidth onChange={(e) => setTitle(e.target.value)} />
                  </Box>

                  <Box flex="1 1 48%">
                    <FormControl fullWidth required>
                      <InputLabel>Category</InputLabel>
                      <Select label="Category" value={category} onChange={(e) => setCategory(e.target.value)}>
                        <MenuItem value="">
                          <em>Select category</em>
                        </MenuItem>
                        {categories.map((cat) => (
                          <MenuItem key={cat.id} value={cat.id}>
                            {cat.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                {/* Description */}
                <Box mt={2}>
                  <Typography variant="subtitle1" gutterBottom>
                    Description *
                  </Typography>
                  <ReactQuill
                    theme="snow"
                    value={description}
                    onChange={(content) => setDescription(content)}
                  />
                </Box>

                {/* ── Template Selection & Banner Image ── */}
                <Box flex="1 1 100%" mt={2.5}>
                  <Divider sx={{ mb: 2.5, borderColor: isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.1)' }} />
                  <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1.5} mb={2}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: isLight ? '#0F172A' : '#FFFFFF' }}>
                        Template Selection & Banner Image
                      </Typography>
                      <HelpTooltip
                        title="Prayer Banner & Template"
                        purpose="Select a visually compelling banner image that represents this prayer closet campaign."
                        howItWorks="Choose an existing curated template from our library or upload your own custom banner image."
                        mobileEffect="Displayed as the top banner image on the prayer screen in the mobile app."
                      />
                    </Box>

                    {/* Live Mobile Preview Button: Normal button, matching standard layout */}
                    <Button
                      size="small"
                      variant="contained"
                      startIcon={<VisibilityIcon sx={{ fontSize: 18, color: '#FFFFFF' }} />}
                      onClick={() => setBasicInfoModal({ open: true, mode: 'preview' })}
                      sx={{
                        borderRadius: '8px',
                        textTransform: 'none',
                        background: 'linear-gradient(135deg, #256974 0%, #3B828E 100%)',
                        color: '#FFFFFF',
                        fontWeight: 700,
                        fontSize: '0.82rem',
                        whiteSpace: 'nowrap',
                        px: 2,
                        height: 36,
                        boxShadow: '0 2px 8px rgba(37, 105, 116, 0.35)',
                        '&:hover': { background: 'linear-gradient(135deg, #1B5058 0%, #256974 100%)' }
                      }}
                    >
                      Live Mobile Preview
                    </Button>
                  </Box>

                  {/* Normal Form Grid: Left = Selected Banner + Choose Template, Right = Upload Custom Template */}
                  <Box display="flex" flexWrap="wrap" gap={2} justifyContent="space-between">
                    {/* Left Column: Current Banner & Choose Template */}
                    <Box flex="1 1 48%">
                      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.8}>
                        <Box display="flex" alignItems="center">
                          <Typography variant="caption" sx={{ fontWeight: 700, color: isLight ? '#475569' : '#CBD5E1' }}>
                            Current Banner Image *
                          </Typography>
                          <HelpTooltip
                            title="Selected Banner"
                            purpose="The banner image that will appear at the top of this prayer."
                            howItWorks="Click 'Choose from Templates' to browse all templates in a popup modal."
                            mobileEffect="Displayed as full-width hero image on mobile."
                          />
                        </Box>
                        <Button
                          size="small"
                          startIcon={<CollectionsBookmarkIcon sx={{ fontSize: 16 }} />}
                          onClick={() => setTemplateModalOpen(true)}
                          sx={{
                            borderRadius: '6px',
                            textTransform: 'none',
                            color: '#64D2E2',
                            backgroundColor: 'rgba(76, 161, 175, 0.15)',
                            border: '1px solid rgba(76, 161, 175, 0.35)',
                            fontWeight: 700,
                            fontSize: '0.78rem',
                            py: 0.3,
                            px: 1.5,
                            '&:hover': {
                              backgroundColor: 'rgba(76, 161, 175, 0.28)',
                              borderColor: '#64D2E2',
                            }
                          }}
                        >
                          Choose from Templates ({templatesList.length})
                        </Button>
                      </Box>

                      {/* Banner Preview Display (normal field styling) */}
                      <Box
                        onClick={() => setTemplateModalOpen(true)}
                        sx={{
                          width: '100%',
                          height: 85,
                          borderRadius: '8px',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          position: 'relative',
                          border: isLight ? '1px solid #CBD5E1' : '1px solid rgba(255, 255, 255, 0.15)',
                          backgroundColor: isLight ? 'rgba(0,0,0,0.03)' : 'rgba(255,255,255,0.03)',
                          transition: 'all 0.2s ease',
                          '&:hover': { borderColor: '#2DD4BF', boxShadow: '0 2px 10px rgba(45, 212, 191, 0.2)' }
                        }}
                      >
                        {customTemplatePreview ? (
                          <img
                            src={customTemplatePreview}
                            alt="Custom Banner Preview"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                        ) : currentActiveTemplate?.url ? (
                          <img
                            src={Image_URL + currentActiveTemplate.url}
                            alt="Selected Template"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                        ) : existingImage ? (
                          <img
                            src={existingImage.startsWith("http") ? existingImage : (Image_URL + existingImage)}
                            alt="Current Banner"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                          />
                        ) : (templatesList[0]?.url) ? (
                          <img
                            src={getTemplateImageUrl(templatesList[0].url, Image_URL)}
                            alt="Selected Template"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            onError={(e) => {
                              const fallbackPath = templatesList[0].url.startsWith('/') ? templatesList[0].url : `/${templatesList[0].url}`;
                              if (!e.currentTarget.src.endsWith(fallbackPath)) {
                                e.currentTarget.src = fallbackPath;
                              }
                            }}
                          />
                        ) : (
                          <Box display="flex" alignItems="center" justifyContent="center" height="100%" gap={1}>
                            <CollectionsBookmarkIcon sx={{ color: '#64D2E2', fontSize: 20 }} />
                            <Typography variant="body2" sx={{ color: isLight ? '#64748B' : 'rgba(255,255,255,0.7)', fontWeight: 600 }}>
                              Click to choose a banner template ({templatesList.length} available)
                            </Typography>
                          </Box>
                        )}

                        <Box
                          sx={{
                            position: 'absolute',
                            bottom: 6,
                            left: 8,
                            right: 8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                          }}
                        >
                          <Chip
                            size="small"
                            label={customTemplatePreview ? "Custom Banner Loaded" : (currentActiveTemplate?.title || "Template Selected")}
                            sx={{
                              height: 20,
                              fontSize: '0.7rem',
                              fontWeight: 700,
                              bgcolor: 'rgba(0,0,0,0.75)',
                              color: '#FFFFFF',
                              backdropFilter: 'blur(4px)'
                            }}
                          />
                          <Typography variant="caption" sx={{ color: '#FFFFFF', fontWeight: 600, fontSize: '0.72rem', textShadow: '0 1px 3px rgba(0,0,0,0.8)' }}>
                            Click to change ↗
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Right Column: Custom Template Upload (Normal field styling, NO dashed box!) */}
                    <Box flex="1 1 48%">
                      <Box display="flex" alignItems="center" mb={0.8}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: isLight ? '#475569' : '#CBD5E1' }}>
                          Custom Banner Upload (Optional)
                        </Typography>
                        <HelpTooltip
                          title="Upload Custom Banner"
                          purpose="Provide your own custom prayer banner image instead of choosing from library templates."
                          howItWorks="Enter an optional template title and click Upload Image."
                          mobileEffect="Displays your uploaded banner on mobile."
                        />
                      </Box>

                      {/* Normal row: TextField + Upload Image Button */}
                      <Box display="flex" gap={1.2} alignItems="center">
                        <TextField
                          placeholder="Custom Template Title"
                          size="small"
                          fullWidth
                          value={customTemplateTitle}
                          onChange={(e) => setCustomTemplateTitle(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                              backgroundColor: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)",
                              height: 40,
                            }
                          }}
                        />
                        <Button
                          variant="contained"
                          component="label"
                          startIcon={<UploadFileIcon sx={{ fontSize: 18, color: '#FFFFFF' }} />}
                          sx={{
                            whiteSpace: "nowrap",
                            height: 40,
                            px: 2,
                            borderRadius: "8px",
                            background: "linear-gradient(135deg, #0D9488 0%, #0F766E 100%)",
                            color: "#FFFFFF",
                            fontWeight: 700,
                            fontSize: "0.82rem",
                            textTransform: "none",
                            flexShrink: 0,
                            boxShadow: "0 2px 6px rgba(13, 148, 136, 0.35)",
                            "&:hover": { background: "#0F766E" }
                          }}
                        >
                          Upload Image
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={handleCustomTemplateUpload}
                          />
                        </Button>
                      </Box>

                      {customTemplatePreview && (
                        <Box mt={1} display="flex" alignItems="center" gap={1}>
                          <Chip
                            size="small"
                            label={customTemplateFile ? customTemplateFile.name : "Custom Image Loaded"}
                            color="success"
                            onDelete={() => {
                              setCustomTemplatePreview(null);
                              setCustomTemplateFile(null);
                              setCustomTemplateTitle('');
                            }}
                            sx={{ fontWeight: 600, fontSize: "0.72rem", height: 24 }}
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>

                {/* ── Template Selection Modal Popup ── */}
                <Dialog
                  open={templateModalOpen}
                  onClose={() => setTemplateModalOpen(false)}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    sx: {
                      borderRadius: '16px',
                      background: isLight ? '#FFFFFF' : '#141d26',
                      border: isLight ? '1px solid #CBD5E1' : '1px solid rgba(76, 161, 175, 0.3)',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                      overflow: 'hidden'
                    }
                  }}
                >
                  <DialogTitle
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderBottom: isLight ? '1px solid #E2E8F0' : '1px solid rgba(255,255,255,0.1)',
                      py: 2,
                      px: 3,
                      background: isLight ? '#F8FAFC' : 'rgba(255,255,255,0.02)'
                    }}
                  >
                    <Box>
                      <Typography variant="h6" fontWeight={800} sx={{ color: isLight ? '#0F172A' : '#FFFFFF', fontSize: '1.1rem' }}>
                        Choose Prayer Banner Template
                      </Typography>
                      <Typography variant="caption" sx={{ color: isLight ? '#64748B' : 'rgba(255,255,255,0.6)', fontSize: '0.78rem' }}>
                        Click a template to apply it as your prayer closet banner ({templatesList.length} templates available)
                      </Typography>
                    </Box>
                    <IconButton onClick={() => setTemplateModalOpen(false)} size="small" sx={{ color: isLight ? '#64748B' : '#94A3B8' }}>
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent sx={{ p: 3, maxHeight: '65vh' }}>
                    {templatesList.length === 0 ? (
                      <Box py={6} textAlign="center">
                        <Typography variant="body1" sx={{ color: isLight ? '#64748B' : 'rgba(255,255,255,0.7)' }}>
                          No templates available. You can upload a custom banner image instead.
                        </Typography>
                      </Box>
                    ) : (
                      <Grid container spacing={2}>
                        {templatesList.map((template) => {
                          const isSelected = String(selectedTemplateId) === String(template.id) && !customTemplatePreview;
                          return (
                            <Grid item xs={12} sm={6} md={4} key={template.id}>
                              <Box
                                onClick={() => {
                                  setSelectedTemplateId(template.id);
                                  setCustomTemplatePreview(null);
                                  setCustomTemplateFile(null);
                                  setTemplateModalOpen(false);
                                }}
                                sx={{
                                  position: 'relative',
                                  border: isSelected
                                    ? '2.5px solid #2DD4BF'
                                    : isLight ? '1.5px solid #E2E8F0' : '1.5px solid rgba(255, 255, 255, 0.12)',
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                  cursor: 'pointer',
                                  height: 140,
                                  boxShadow: isSelected ? '0 0 16px rgba(45, 212, 191, 0.4)' : '0 2px 6px rgba(0,0,0,0.1)',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    borderColor: '#2DD4BF',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 8px 18px rgba(0,0,0,0.25)'
                                  }
                                }}
                              >
                                <img
                                  src={getTemplateImageUrl(template.url, Image_URL)}
                                  alt={template.title}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    display: 'block'
                                  }}
                                  onError={(e) => {
                                    const fallbackPath = template.url.startsWith('/') ? template.url : `/${template.url}`;
                                    if (!e.currentTarget.src.endsWith(fallbackPath)) {
                                      e.currentTarget.src = fallbackPath;
                                    }
                                  }}
                                />
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    p: 1,
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 70%, transparent 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <Typography variant="caption" sx={{ color: '#FFFFFF', fontWeight: 700, fontSize: '0.78rem' }} noWrap>
                                    {template.title || `Template #${template.id}`}
                                  </Typography>
                                  {isSelected && (
                                    <Chip
                                      size="small"
                                      label="Selected"
                                      sx={{
                                        height: 18,
                                        fontSize: '0.65rem',
                                        fontWeight: 800,
                                        bgcolor: '#2DD4BF',
                                        color: '#042F2E',
                                      }}
                                    />
                                  )}
                                </Box>
                                {/* Delete button if user has permission */}
                                {canDeleteTemplate(template) && (
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteClick(template);
                                    }}
                                    sx={{
                                      position: 'absolute',
                                      top: 6,
                                      right: 6,
                                      backgroundColor: 'rgba(0,0,0,0.65)',
                                      color: '#EF4444',
                                      p: 0.5,
                                      '&:hover': { backgroundColor: 'rgba(239,68,68,0.9)', color: '#fff' }
                                    }}
                                  >
                                    <DeleteIcon sx={{ fontSize: 16 }} />
                                  </IconButton>
                                )}
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    )}
                  </DialogContent>

                  <DialogActions sx={{ px: 3, py: 1.5, borderTop: isLight ? '1px solid #E2E8F0' : '1px solid rgba(255,255,255,0.1)' }}>
                    <Button
                      onClick={() => setTemplateModalOpen(false)}
                      sx={{ color: isLight ? '#64748B' : '#94A3B8', textTransform: 'none', fontWeight: 600 }}
                    >
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>


              </AccordionDetails>
            </Accordion>

            {/* Modal for Basic Information User Example & Live Preview */}
            <MobileSpecialPrayerModal
              open={basicInfoModal.open}
              onClose={() => setBasicInfoModal({ ...basicInfoModal, open: false })}
              isExample={basicInfoModal.mode === 'example'}
              title={title}
              bannerImage={
                customTemplatePreview ||
                (currentActiveTemplate?.url
                  ? Image_URL + currentActiveTemplate.url
                  : (existingImage ? (existingImage.startsWith("http") ? existingImage : Image_URL + existingImage) : (templatesList[0]?.url ? Image_URL + templatesList[0].url : "")))
              }
              duration={numDays || numberOfDays || 40}
              format={prayerType}
              description={description}
            />

            {/* Schedule Section */}
            <Accordion defaultExpanded sx={{ border: '1px solid #256974ff', borderRadius: '12px !important', boxShadow: 'none', '&:before': { display: 'none' } }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} sx={{ background: '#256974ff', borderBottom: '1px solid #e2e8f0' }}>
                <Typography fontWeight={600} color="#fff">Schedule Settings</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 3 }}>





                <Box
                  display="grid"
                  gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
                  gap={2.5}
                  alignItems="start"
                  mt={3}
                >
                  {/* 1. Prayer Plan Selection */}
                  <Box>
                    <Box display="flex" alignItems="center" gap={0.75} mb={0.75} sx={{ height: 24 }}>
                      <Typography variant="subtitle2" fontWeight={600} sx={{ color: "white", fontSize: "0.88rem" }}>
                        Prayer Plan *
                      </Typography>
                      <HelpTooltip
                        title="Prayer Plan"
                        purpose="Specifies whether the prayer schedule is Fixed, Floating, or Open."
                        howItWorks="You can change an existing Fixed or Floating Prayer to Open Prayer here. Open Prayer has no fixed end date."
                        mobileEffect="Modifies how slots and dates are scheduled and rendered on the mobile app."
                      />
                    </Box>
                    <FormControl fullWidth required>
                      <Select
                        id="edit-prayer-plan-select"
                        value={prayerPlan}
                        onChange={(e) => setPrayerPlan(e.target.value)}
                        displayEmpty
                        sx={{
                          height: 50,
                          borderRadius: "10px",
                          backgroundColor: "rgba(255, 255, 255, 0.04)",
                          color: "white",
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "&:hover": {
                            backgroundColor: "rgba(76, 161, 175, 0.08)",
                            borderColor: "#64d2e2",
                          },
                          "& .MuiSvgIcon-root": { color: "rgba(255, 255, 255, 0.7)" },
                        }}
                      >
                        <MenuItem value="fixed">Fixed Prayer</MenuItem>
                        <MenuItem value="floating">Floating Prayer</MenuItem>
                        <MenuItem value="open">Open Prayer (Convert Existing)</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  {/* 2. Single Unified Date & Time Range Picker */}
                  <Box>
                    <DateTimeRangePicker
                      prayerPlan={prayerPlan}
                      fromDate={fromDate}
                      toDate={toDate}
                      fromTime={fromTime}
                      toTime={toTime}
                      numberOfDays={numberOfDays}
                      onFromDateChange={(val) => setFromDate(val)}
                      onToDateChange={(val) => setTodate(val)}
                      onFromTimeChange={(val) => setfromTime(val)}
                      onToTimeChange={(val) => setToTime(val)}
                      onNumberOfDaysChange={(val) => setNumberOfDays(val)}
                    />
                  </Box>

                  {/* 3. Slot Duration */}
                  <Box>
                    <Box display="flex" alignItems="center" gap={0.75} mb={0.75} sx={{ height: 24 }}>
                      <Typography variant="subtitle2" fontWeight={600} sx={{ color: "white", fontSize: "0.88rem" }}>
                        Slot Duration *
                      </Typography>
                      <HelpTooltip
                        title="Slot Duration"
                        purpose="Specifies the duration of each individual prayer slot in minutes."
                        howItWorks="The schedule window is divided into blocks of 10, 15, 30, or 60 minutes."
                        mobileEffect="Users will choose and pray in slots of this length in the mobile app."
                      />
                    </Box>
                    <FormControl fullWidth required>
                      <Select
                        id="edit-slot-duration-select"
                        value={slotDuration}
                        onChange={(e) => setSlotDuration(e.target.value)}
                        displayEmpty
                        sx={{
                          height: 50,
                          borderRadius: "10px",
                          backgroundColor: "rgba(255, 255, 255, 0.04)",
                          color: "white",
                          border: "1px solid rgba(255, 255, 255, 0.15)",
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "&:hover": {
                            backgroundColor: "rgba(76, 161, 175, 0.08)",
                            borderColor: "#64d2e2",
                          },
                          "& .MuiSvgIcon-root": { color: "rgba(255, 255, 255, 0.7)" },
                        }}
                      >
                        <MenuItem value="" disabled>
                          <span style={{ color: "rgba(255, 255, 255, 0.45)" }}>Select Slot Duration</span>
                        </MenuItem>
                        <MenuItem value="10">10 minutes</MenuItem>
                        <MenuItem value="15">15 minutes</MenuItem>
                        <MenuItem value="30">30 minutes</MenuItem>
                        <MenuItem value="60">60 minutes</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  {/* 4. Schedule Summary Card */}
                  <Box>
                    <Box display="flex" alignItems="center" gap={0.75} mb={0.75} sx={{ height: 24 }}>
                      <Typography variant="subtitle2" fontWeight={600} sx={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "0.88rem" }}>
                        Schedule Summary
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        height: 50,
                        px: 2,
                        boxSizing: "border-box",
                        borderRadius: "10px",
                        backgroundColor: "rgba(76, 161, 175, 0.08)",
                        border: "1px dashed rgba(76, 161, 175, 0.4)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1.5,
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#64d2e2",
                            fontWeight: 600,
                            fontSize: "0.85rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {numDays > 0 ? `${numDays} Day${numDays > 1 ? "s" : ""} Total` : "Duration Pending"}
                          {fromTime && toTime ? ` • ${fromTime} to ${toTime}` : ""}
                        </Typography>
                      </Box>
                      {slotDuration ? (
                        <Chip
                          size="small"
                          label={`${slotDuration}m slots`}
                          sx={{
                            bgcolor: "rgba(76, 161, 175, 0.25)",
                            color: "#FFFFFF",
                            fontWeight: 600,
                            fontSize: "0.72rem",
                            height: 24,
                            flexShrink: 0,
                          }}
                        />
                      ) : (
                        <Typography variant="caption" sx={{ color: "rgba(255, 255, 255, 0.4)", fontSize: "0.75rem", flexShrink: 0 }}>
                          No duration set
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                <Box
                  display="flex"
                  flexWrap="wrap"
                  gap={2}
                  justifyContent="space-between"
                  mt={5}
                >
                  {/* Pray Type */}
                  <Box flex="1 1 48%" mt={2}>
                    <Typography variant="subtitle1" gutterBottom>
                      Pray Type *
                    </Typography>
                    <RadioGroup
                      row
                      value={prayerType}
                      onChange={(e) => setPrayerType(e.target.value)}
                    >
                      <FormControlLabel
                        value="Group"
                        control={<Radio />}
                        label="Group"
                      />
                      <FormControlLabel
                        value="Personal"
                        control={<Radio />}
                        label="Personal"
                      />
                    </RadioGroup>
                  </Box>

                  {/* Prayer Frequency */}
                  <Box flex="1 1 48%" mt={2}>
                    <Typography variant="subtitle1" gutterBottom>
                      Prayer Frequency *
                    </Typography>
                    <RadioGroup
                      row
                      value={prayerFrequency}
                      onChange={(e) => setPrayerFrequency(e.target.value)}
                    >
                      <FormControlLabel
                        value="Daily"
                        control={<Radio />}
                        label="Daily"
                      />
                      <FormControlLabel
                        value="Weekly"
                        control={<Radio />}
                        label="Weekly"
                      />
                    </RadioGroup>
                  </Box>


                  {prayerFrequency == "Weekly" && (
                    <Box flex="1 1 48%" mt={2}>
                      <FormControl fullWidth>
                        <InputLabel>Day of Week</InputLabel>
                        <Select
                          multiple
                          value={daysOfWeek}
                          onChange={(e) => setDaysOfWeek(e.target.value)}
                          label="Day of Week"
                          renderValue={(selected) => selected.join(', ')}
                        >
                          {[
                            'Sunday',
                            'Monday',
                            'Tuesday',
                            'Wednesday',
                            'Thursday',
                            'Friday',
                            'Saturday',
                          ].map((day) => (
                            <MenuItem key={day} value={day}>
                              <Checkbox checked={daysOfWeek.indexOf(day) > -1} />
                              <ListItemText primary={day} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Day-wise Content Section */}
            <Accordion defaultExpanded sx={{ border: '1px solid #256974ff', borderRadius: '12px !important', boxShadow: 'none', '&:before': { display: 'none' } }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} sx={{ background: '#256974ff', borderBottom: '1px solid #e2e8f0' }}>
                <Typography fontWeight={600} color="#fff">Day-Wise Content ({numDays} Days)</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 3 }}>

                {/* Toolbar */}
                <Box sx={{ mb: 2, p: 2, background: 'rgba(255,255,255,0.03)', borderRadius: 2, border: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box display="flex" flexWrap="wrap" alignItems="center" gap={1.5}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sameContentForAllDays}
                          onChange={(e) => handleToggleSameContent(e.target.checked)}
                          sx={{
                            color: '#4CA1AF',
                            '&.Mui-checked': { color: '#64d2e2' }
                          }}
                        />
                      }
                      label={
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Typography sx={{ fontWeight: 700, color: '#F1F5F9', fontSize: '0.92rem' }}>
                            Same prayer for all days
                          </Typography>
                          <HelpTooltip
                            title="Same prayer for all days"
                            purpose="When checked, Day 1 content is automatically used for all days."
                            howItWorks="Configure Day 1, and every day in the initiative will use the same content."
                            mobileEffect="Intercessors see the same devotion for each day."
                          />
                        </Box>
                      }
                    />

                    {numDays > 1 && (
                      <Box display="flex" alignItems="center">
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<ContentCopyIcon />}
                          onClick={handleApplyDay1ToAll}
                          disabled={!(dayWiseData[1]?.prayerPoints?.length > 0 || dayWiseData[1]?.title)}
                          sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            borderColor: '#4CA1AF',
                            color: '#64d2e2',
                            fontWeight: 600,
                            fontSize: '0.85rem',
                            '&:hover': { borderColor: '#64d2e2', background: 'rgba(76, 161, 175, 0.15)' }
                          }}
                        >
                          Apply Day 1 to All Days
                        </Button>
                        <HelpTooltip
                          title="Apply Day 1 to All Days"
                          purpose="Instantly clones Day 1's title, description, and prayer points into every subsequent day."
                          howItWorks="Copies Day 1 content into Days 2, 3, etc. as an editable starting point, saving you from entering repeated information."
                          mobileEffect="Intercessors see consistent daily content and starter points across all days of the prayer."
                        />
                      </Box>
                    )}
                  </Box>
                </Box>

                <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', pb: 2, display: 'flex', gap: 1 }}>
                  {Array.from({ length: numDays }, (_, i) => i + 1).map((day) => (
                    <Button
                      key={day}
                      variant={currentDay === day ? "contained" : "outlined"}
                      color={currentDay === day ? "primary" : "inherit"}
                      onClick={() => handleOpenDay(day)}
                      sx={{
                        borderRadius: "20px",
                        fontWeight: 600,
                        textTransform: "none",
                        minWidth: '100px',
                        flexShrink: 0,
                        borderColor: currentDay === day ? '' : '#cbd5e1',
                        color: currentDay === day ? 'white' : '#cbd5e1'
                      }}
                    >
                      Day {day}
                    </Button>
                  ))}
                </Box>

                {currentDay && (
                  <Accordion defaultExpanded sx={{ mt: 2, border: '1px dashed #cbd5e1', borderRadius: 2, boxShadow: 'none', '&:before': { display: 'none' } }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ background: '#256974ff', borderRadius: '12px !important', borderBottom: '1px dashed #cbd5e1' }}>
                      <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap" width="100%">
                        <Typography fontWeight={700} color="#fff" fontSize="1rem">Day {currentDay} Configuration</Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 3 }}>
                        <Box sx={{ mb: 2, border: "1px solid #ddd", borderRadius: 2, p: 2 }}>
                          <Tabs
                            value={dayWiseData[currentDay]?.currentLang || "en"}
                            onChange={(e, newVal) => handleInputChange("currentLang", newVal)}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
                          >
                            <Tab label="English" value="en" />
                            <Tab label="Telugu" value="te" />
                            <Tab label="Tamil" value="ta" />
                            <Tab label="Malayalam" value="ml" />
                            <Tab label="Hindi" value="hi" />
                          </Tabs>

                          {/* ENGLISH */}
                          {(dayWiseData[currentDay]?.currentLang === "en" || !dayWiseData[currentDay]?.currentLang) && (
                            <>
                              <TextField
                                label="Title (English)"
                                fullWidth
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.title || ""}
                                onChange={(e) => handleInputChange("title", e.target.value)}
                              />
                              <TextField
                                label="Description (English)"
                                fullWidth
                                multiline
                                minRows={2}
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.description || ""}
                                onChange={(e) => handleInputChange("description", e.target.value)}
                              />

                              <Box sx={{ mt: 1, mb: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>Translate to:</Typography>
                                <FormControl size="small" sx={{ minWidth: 200 }}>
                                  <Select
                                    displayEmpty
                                    value=""
                                    onChange={(e) => handleTranslateDayContent(e.target.value)}
                                    sx={{
                                      borderRadius: '8px',
                                      '& .MuiSelect-select': {
                                        py: 1
                                      }
                                    }}
                                  >
                                    <MenuItem value="" disabled>
                                      <em>Select Language</em>
                                    </MenuItem>
                                    <MenuItem value="te">Telugu (తెలుగు)</MenuItem>
                                    <MenuItem value="ta">Tamil (தமிழ்)</MenuItem>
                                    <MenuItem value="ml">Malayalam (മലയാളം)</MenuItem>
                                    <MenuItem value="hi">Hindi (हिंदी)</MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                              <Typography variant="body2" sx={{ display: 'block', mt: -1, mb: 2, color: '#f59e0b', fontStyle: 'italic', fontSize: '0.875rem' }}>
                                ⚠️ Please review the translation carefully. Auto-translations may not always be accurate. Verify and edit before adding to your prayer points.
                              </Typography>
                            </>
                          )}

                          {/* TELUGU */}
                          {dayWiseData[currentDay]?.currentLang === "te" && (
                            <>
                              <TextField
                                label="Title (Telugu)"
                                fullWidth
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.te_title || ""}
                                onChange={(e) => handleInputChange("te_title", e.target.value)}
                              />
                              <TextField
                                label="Description (Telugu)"
                                fullWidth
                                multiline
                                minRows={2}
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.te_description || ""}
                                onChange={(e) => handleInputChange("te_description", e.target.value)}
                              />
                            </>
                          )}

                          {/* TAMIL */}
                          {dayWiseData[currentDay]?.currentLang === "ta" && (
                            <>
                              <TextField
                                label="Title (Tamil)"
                                fullWidth
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.ta_title || ""}
                                onChange={(e) => handleInputChange("ta_title", e.target.value)}
                              />
                              <TextField
                                label="Description (Tamil)"
                                fullWidth
                                multiline
                                minRows={2}
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.ta_description || ""}
                                onChange={(e) => handleInputChange("ta_description", e.target.value)}
                              />
                            </>
                          )}

                          {/* MALAYALAM */}
                          {dayWiseData[currentDay]?.currentLang === "ml" && (
                            <>
                              <TextField
                                label="Title (Malayalam)"
                                fullWidth
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.ml_title || ""}
                                onChange={(e) => handleInputChange("ml_title", e.target.value)}
                              />
                              <TextField
                                label="Description (Malayalam)"
                                fullWidth
                                multiline
                                minRows={2}
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.ml_description || ""}
                                onChange={(e) => handleInputChange("ml_description", e.target.value)}
                              />
                            </>
                          )}

                          {/* HINDI */}
                          {dayWiseData[currentDay]?.currentLang === "hi" && (
                            <>
                              <TextField
                                label="Title (Hindi)"
                                fullWidth
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.hi_title || ""}
                                onChange={(e) => handleInputChange("hi_title", e.target.value)}
                              />
                              <TextField
                                label="Description (Hindi)"
                                fullWidth
                                multiline
                                minRows={2}
                                sx={{ mb: 2 }}
                                value={dayWiseData[currentDay]?.hi_description || ""}
                                onChange={(e) => handleInputChange("hi_description", e.target.value)}
                              />
                            </>
                          )}

                          <Box sx={{ mb: 2 }}>
                            <Button variant="outlined" component="label" sx={{ borderColor: '#0F766E', color: '#0F766E', fontWeight: 600, textTransform: 'none', borderRadius: '8px' }}>
                              Upload Image
                              <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => handleInputChange("image", e.target.files[0])}
                              />
                            </Button>
                            {dayWiseData[currentDay]?.image && (
                              <Box sx={{ mt: 1 }}>
                                <Typography variant="body2">
                                  {dayWiseData[currentDay].image instanceof File
                                    ? `Selected: ${dayWiseData[currentDay].image.name}`
                                    : "Current Image:"}
                                </Typography>
                                {!(dayWiseData[currentDay].image instanceof File) && (
                                  <img
                                    src={dayWiseData[currentDay].image.startsWith('http') ? dayWiseData[currentDay].image : `${Image_URL}${dayWiseData[currentDay].image}`}
                                    alt="Day Content"
                                    style={{ maxWidth: '200px', maxHeight: '150px', marginTop: '5px', borderRadius: '4px' }}
                                  />
                                )}
                              </Box>
                            )}
                          </Box>

                          {/* Video Option (YouTube / Supported Video Link) */}
                          <PrayerVideoManager
                            dayNumber={currentDay}
                            videos={dayWiseData[currentDay]?.videos || []}
                            isLight={false}
                            onVideosChange={(updatedVideos) => {
                              handleInputChange("videos", updatedVideos);
                              const firstPublished = updatedVideos.find((v) => v.is_published);
                              handleInputChange("video_url", firstPublished ? firstPublished.url : "");
                              handleInputChange("video_title", firstPublished ? firstPublished.title : "");
                              handleInputChange("video_thumbnail", firstPublished ? firstPublished.thumbnail : "");
                            }}
                          />
                        </Box>

                      <Box>
                        {(dayWiseData[currentDay]?.prayerPoints || []).map((item, index) => (
                          <Box key={index} sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2, mb: 2 }}>
                            <Tabs
                              value={item.currentLang || "en"}
                              onChange={(e, newVal) => handleDailyPrayerPointChange(index, "currentLang", newVal)}
                              indicatorColor="primary"
                              textColor="primary"
                              variant="scrollable"
                              scrollButtons="auto"
                              sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
                            >
                              <Tab label="English" value="en" />
                              <Tab label="Telugu" value="te" />
                              <Tab label="Tamil" value="ta" />
                              <Tab label="Malayalam" value="ml" />
                              <Tab label="Hindi" value="hi" />
                            </Tabs>

                            {/* ENGLISH */}
                            {(item.currentLang === "en" || !item.currentLang) && (
                              <>
                                <TextField
                                  label="Title (English)"
                                  fullWidth
                                  sx={{ mb: 2 }}
                                  value={item.title || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "title", e.target.value)}
                                />
                                <TextField
                                  label="Description (English)"
                                  fullWidth
                                  multiline
                                  minRows={2}
                                  sx={{ mb: 2 }}
                                  value={item.description || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "description", e.target.value)}
                                />

                                <Box sx={{ mt: 1, mb: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
                                  <Typography variant="body2" sx={{ fontWeight: 500 }}>Translate to:</Typography>
                                  <FormControl size="small" sx={{ minWidth: 200 }}>
                                    <Select
                                      displayEmpty
                                      value=""
                                      onChange={(e) => handleTranslatePrayerPoint(index, e.target.value)}
                                      sx={{
                                        borderRadius: '8px',
                                        '& .MuiSelect-select': {
                                          py: 1
                                        }
                                      }}
                                    >
                                      <MenuItem value="" disabled>
                                        <em>Select Language</em>
                                      </MenuItem>
                                      <MenuItem value="te">Telugu (తెలుగు)</MenuItem>
                                      <MenuItem value="ta">Tamil (தமிழ்)</MenuItem>
                                      <MenuItem value="ml">Malayalam (മലയാളം)</MenuItem>
                                      <MenuItem value="hi">Hindi (हिंदी)</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>
                                <Typography variant="body2" sx={{ display: 'block', mt: -1, mb: 2, color: '#f59e0b', fontStyle: 'italic', fontSize: '0.875rem' }}>
                                  ⚠️ Please review the translation carefully. Auto-translations may not always be accurate. Verify and edit before adding to your prayer points.
                                </Typography>
                              </>
                            )}

                            {/* TELUGU */}
                            {item.currentLang === "te" && (
                              <>
                                <TextField
                                  label="Title (Telugu)"
                                  fullWidth
                                  sx={{ mb: 2 }}
                                  value={item.te_title || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "te_title", e.target.value)}
                                />
                                <TextField
                                  label="Description (Telugu)"
                                  fullWidth
                                  multiline
                                  minRows={2}
                                  sx={{ mb: 2 }}
                                  value={item.te_description || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "te_description", e.target.value)}
                                />
                              </>
                            )}

                            {/* TAMIL */}
                            {item.currentLang === "ta" && (
                              <>
                                <TextField
                                  label="Title (Tamil)"
                                  fullWidth
                                  sx={{ mb: 2 }}
                                  value={item.ta_title || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "ta_title", e.target.value)}
                                />
                                <TextField
                                  label="Description (Tamil)"
                                  fullWidth
                                  multiline
                                  minRows={2}
                                  sx={{ mb: 2 }}
                                  value={item.ta_description || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "ta_description", e.target.value)}
                                />
                              </>
                            )}

                            {/* MALAYALAM */}
                            {item.currentLang === "ml" && (
                              <>
                                <TextField
                                  label="Title (Malayalam)"
                                  fullWidth
                                  sx={{ mb: 2 }}
                                  value={item.ml_title || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "ml_title", e.target.value)}
                                />
                                <TextField
                                  label="Description (Malayalam)"
                                  fullWidth
                                  multiline
                                  minRows={2}
                                  sx={{ mb: 2 }}
                                  value={item.ml_description || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "ml_description", e.target.value)}
                                />
                              </>
                            )}

                            {/* HINDI */}
                            {item.currentLang === "hi" && (
                              <>
                                <TextField
                                  label="Title (Hindi)"
                                  fullWidth
                                  sx={{ mb: 2 }}
                                  value={item.hi_title || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "hi_title", e.target.value)}
                                />
                                <TextField
                                  label="Description (Hindi)"
                                  fullWidth
                                  multiline
                                  minRows={2}
                                  sx={{ mb: 2 }}
                                  value={item.hi_description || ""}
                                  onChange={(e) => handleDailyPrayerPointChange(index, "hi_description", e.target.value)}
                                />
                              </>
                            )}

                            <Box textAlign="right">
                              <Button variant="outlined" color="error" onClick={() => removePrayerPoint(index)}>
                                Remove
                              </Button>
                            </Box>
                          </Box>
                        ))}

                        <Button variant="outlined" color="success" onClick={addPrayerPoint}>
                          + Add Prayer Content
                        </Button>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}







                {/* Scripture */}
                <Box flex="1 1 100%" mt={2}>
                  {/* <Typography variant="subtitle1" gutterBottom>
    Prayer Points:
  </Typography>

  {prayerPoints.map((point, index) => (
    <Box key={index} mt={2} display="flex" flexDirection="column" gap={2}>
      <TextField
        label={`Prayer Topic ${index + 1}`}
        value={point.title}
        onChange={(e) => handlePrayerPointChange(index, 'title', e.target.value)}
        fullWidth
      />
      
      <TextField
        label="English Prayer Point"
        value={point.english}
        onChange={(e) => handlePrayerPointChange(index, 'english', e.target.value)}
        fullWidth
      />
      <TextField
        label="Telugu Prayer Point"
        value={point.telugu}
        onChange={(e) => handlePrayerPointChange(index, 'telugu', e.target.value)}
        fullWidth
      />
    </Box>
  ))} */}






                  {/* Render generated points */}
                  {generatedPoints.map((point, index) => (
                    <Box
                      key={index}
                      mt={2}
                      p={2}
                      border="1px solid #ccc"
                      borderRadius={2}
                      display="flex"
                      flexDirection="column"
                      gap={2}
                    >
                      <Typography variant="h6">{point.title}</Typography>

                      <TextField
                        label={`English Prayer Point`}
                        value={point.english}
                        onChange={(e) =>
                          handlePrayerPointChange(index, "english", e.target.value)
                        }
                        fullWidth
                      />

                      <TextField
                        label="Telugu Prayer Point"
                        value={point.telugu}
                        onChange={(e) =>
                          handlePrayerPointChange(index, "telugu", e.target.value)
                        }
                        fullWidth
                      />

                      <Button
                        variant="outlined"
                        color="success"
                        onClick={() => approvePrayerPoint(index)}
                      >
                        Approve
                      </Button>
                    </Box>
                  ))}












                  {user?.role === 1 && (

                    <Button variant="contained" onClick={generatePrayerPoints} sx={{ mt: 2 }}>
                      Generate Prayer Points
                    </Button>
                  )


                  }

                </Box>
              </AccordionDetails>
            </Accordion>



            {/* Action Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4, flexWrap: "wrap", alignItems: "center" }}>
              {(user?.role === 1 || (user?.role !== 1 && user?.org_id === Number(orgId))) && (
                <>
                  <Button
                    variant="outlined"
                    onClick={() => handleAddDevotion(false)}
                    sx={{
                      borderColor: '#0F766E',
                      color: isLight ? '#0F766E' : '#5EEAD4',
                      height: 48,
                      padding: '0 24px',
                      fontSize: '0.92rem',
                      borderRadius: '50px',
                      fontWeight: 600,
                      textTransform: 'none',
                      '&:hover': { borderColor: '#115E59', bgcolor: 'rgba(15, 118, 110, 0.06)' }
                    }}
                  >
                    💾 Save as Draft / Inactive
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleAddDevotion(true)}
                    sx={{
                      background: 'linear-gradient(45deg, #11998e 30%, #38ef7d 90%)',
                      boxShadow: '0 3px 5px 2px rgba(56, 239, 125, .3)',
                      color: 'white',
                      height: 48,
                      padding: '0 30px',
                      fontSize: '1rem',
                      borderRadius: '50px',
                      fontWeight: 700,
                      textTransform: 'none'
                    }}
                  >
                    {prayerStatus === 'active' ? "Update & Keep Live ✨" : "Submit & Publish to Live ✨"}
                  </Button>
                </>
              )}
            </Box>

          </Box>
        </Paper>
        <Toast toast={toast} setToast={setToast} />

        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          PaperProps={{
            sx: {
              background: 'rgba(30, 41, 59, 0.95)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 3,
              p: 1
            },
          }}
        >
          <DialogTitle sx={{ color: '#FFFFFF', fontWeight: 700 }}>
            Confirm Delete Template
          </DialogTitle>
          <DialogContent>
            <Typography sx={{ color: 'rgba(255,255,255,0.8)', mb: 2 }}>
              Are you sure you want to delete the template "{templateToDelete?.title}"?
            </Typography>
            <Typography sx={{ color: '#f59e0b', fontSize: '0.875rem', fontStyle: 'italic' }}>
              ⚠️ This action cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button
              onClick={() => setDeleteDialogOpen(false)}
              sx={{ color: 'rgba(255,255,255,0.6)', '&:hover': { color: '#FFFFFF' } }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeleteConfirm}
              variant="contained"
              color="error"
              sx={{
                background: 'rgba(239, 68, 68, 0.2)',
                color: '#EF4444',
                border: '1px solid rgba(239, 68, 68, 0.5)',
                '&:hover': { background: 'rgba(239, 68, 68, 0.3)' }
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
